export default __webpack_public_path__ + "static/media/FooterFinalNew.5a17c0d5.glb";